module.exports = __webpack_public_path__ + "img/3.218d85d5.jpg";